/* global axios */
import ApiClient from './ApiClient';

class LeadSourcesAPI extends ApiClient {
  constructor() {
    super('lead_sources', { accountScoped: true, apiVersion: 'v2' });
  }

  // Filtros opcionais: kind, active.
  list(params = {}) {
    return axios.get(this.url, { params });
  }

  rotateToken(id) {
    return axios.post(`${this.url}/${id}/rotate_token`);
  }

  runNow(id) {
    return axios.post(`${this.url}/${id}/run_now`);
  }
}

export default new LeadSourcesAPI();
